import httpService from '@/services/httpService'

const actions = {
  getRankReportData: async function ({ commit, dispatch }, { clientId, filters }) {
    const params = { filters: JSON.stringify(filters) }
    const response = await httpService.get(`/rank-report/${clientId}`, { params })
    return response.data
  },
  createNewRankReport: function ({ commit }, { clientId, rankReport }) {
    rankReport = {
      id: rankReport.id,
      source_id: rankReport.source_id,
      type_id: rankReport.type_id
    }
    return httpService.post(`/rank-report/${clientId}`, rankReport,
      { successMessage: 'Rank Report successfully created', raiseError: true, cancelErrorMessage: true })
  },
  updateRankReport: function ({ commit }, { clientId, rankReport }) {
    rankReport = {
      id: rankReport.id,
      pause: rankReport.timestamp_deleted ? 0 : 1
    }
    return httpService.patch(`/rank-report/${clientId}`, rankReport,
      { successMessage: 'Rank Report successfully updated', raiseError: true, cancelErrorMessage: true })
  },
  getRankReportOptions: async function ({ commit , dispatch}) {
    const response = await httpService.get('/rank-report/options')
    return response.data
  },
  deleteRankReports: function ({ commit }, { clientId, rankReports }) {
    const data = { rank_reports: rankReports };
    const response = httpService.post(`/rank-report/${clientId}/delete`, data, {
      successMessage: 'Rank Reports deleted successfully',
    });
    return response.data
  },
}

export default {
  namespaced: true,
  actions
}
